import { Fragment } from 'react';
import { CSSTransition } from 'react-transition-group';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { rage } from '~/rage';
import { Layouts } from '~/shared';
import { useLayoutSelector } from '../../redux/hooks';
import { Shadow } from '../Shadow';
import { StyledContainer } from './Background.styled';

const Background: React.FC = () => {
	const interfaceHidden = useLayoutSelector(
		(state) => state.photoMode.interfaceHidden,
	);

	return (
		<Fragment>
			{rage.config.isStub() && (
				<BgPlaceholder $type={PlaceholderType.PhotoMode} />
			)}
			<StyledContainer className={`${Layouts.PhotoMode}-background`}>
				<CSSTransition in={interfaceHidden} classNames={'shadow'} timeout={500}>
					<Shadow />
				</CSSTransition>
			</StyledContainer>
		</Fragment>
	);
};

export { Background };
